import { trackEvent } from '../../helpers/tracking/track.js';
import digitalDataProduct from '../../helpers/tracking/digitalDataProduct.js';
import getClosestComponentID from '../../helpers/tracking/getClosestComponentID.js';

window.addEventListener('addwishlistitem', ({ detail: { items, wishlist, relatedTarget } }) =>
  trackEvent('addwishlistitem', getClosestComponentID(relatedTarget) ?? 'Toolbar', {
    item: items.map(({ prid, catalog, offer, quantity, availability, nature, eqNatures, sellerTypes }) =>
      digitalDataProduct({ prid, catalog, offer, quantity, availability, nature, eqNatures, sellerTypes })
    ),
    wishlist,
  })
);
